import React from 'react';
import { connect } from 'react-redux';
import { toUrl } from '../../common/services/navigation';
import * as Actions from '../../common/services/actions';

function TabItem({ currentSearch, search, type, children, toggleTabList, settings }) {
	
	let selected = null;
	let isActive = false;
	let c = "events-listing-filter__item";
	if (currentSearch.searchType === search || 
		currentSearch.eventType === search || 
		(!currentSearch.searchType && !currentSearch.eventType && search.toLowerCase() === 'all')) {
		selected = 'true';
		isActive = true;
		c="events-listing-filter__item active"
	}

	const url = toUrl(currentSearch, { [type]: search.toLowerCase() != 'all' ? search : '', pageIndex: 0 }, settings);

	const toggleTabListClick = (e) => {
		if (isActive) {
			e.preventDefault();
			e.stopPropagation();
			toggleTabList();
		}
	};
	return (
		<li className={c}>
			<a href={url} className="events-listing-filter__link" onClick={toggleTabListClick} aria-selected={selected}>{children}</a>
		</li>
	);
}


const mapDispatchToProps = dispatch => ({
	toggleTabList: () => {
		dispatch(Actions.toggleTabList());
	}
});

export default connect(null, mapDispatchToProps)(TabItem);
